import { useNavigate, useLocation } from "react-router-dom";
import { Grid, Button, useTheme } from "@mui/material";
import { createElement } from "react";
import {
  ACCOUNT_PAYROLL_ROUTE,
  ATTENDANCE,
  SALARY_DASHBOARD,
} from "../../constants/routes";
import { MdOutlinePayments } from "react-icons/md";
import { BsFileSpreadsheet } from "react-icons/bs";
import { FaStamp } from "react-icons/fa";

export default function NavigationTabs() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const isActive = (href) =>
    location.pathname === href || location.pathname.startsWith(href + "/");

  const handleClick = (href) => navigate(href);

  const items = [
    { title: "Payroll", icon: MdOutlinePayments, href: ACCOUNT_PAYROLL_ROUTE },
    { title: "Salary Statements", icon: BsFileSpreadsheet, href: SALARY_DASHBOARD },
    { title: "Attendance", icon: FaStamp, href: ATTENDANCE },
  ];

  return (
    <Grid
      container
      spacing={1.5}
      sx={{
        width: { xs: "100%", md: "auto" },
      }}
    >
      {items.map(({ title, icon, href }) => {
        const active = isActive(href);
        return (
          <Grid item xs={12} sm="auto" key={href}>
            <Button
              fullWidth
              variant="outlined"
              startIcon={icon ? createElement(icon, { size: 18 }) : null}
              onClick={() => handleClick(href)}
              sx={{
                textTransform: "none",
                borderRadius: 3,
                px: { xs: 2, sm: 2.5 },
                py: { xs: 1, sm: 1.1 },
                fontWeight: 700,
                fontSize: { xs: "0.9rem", sm: "0.95rem" },
                transition: "all .25s ease",
                border: active
                  ? "2px solid #56C662"
                  : `2px solid ${
                      isDark
                        ? "rgba(86,198,98,0.35)"
                        : "rgba(5,150,105,0.2)"
                    }`,
                // Use `background` for gradients
                background: active
                  ? "linear-gradient(135deg,#56C662,#10b981)"
                  : theme.palette.background.paper,
                color: active
                  ? "white"
                  : isDark
                  ? theme.palette.primary.main
                  : "#56C662",
                boxShadow: active
                  ? "0 3px 10px rgba(5,150,105,0.25)"
                  : isDark
                  ? "none"
                  : "0 2px 6px rgba(0,0,0,0.05)",
                "&:hover": {
                  background: active
                    ? "linear-gradient(135deg,#047857,#56C662)"
                    : isDark
                    ? "rgba(86,198,98,0.12)"
                    : "#f0fdf4",
                  borderColor: "#56C662",
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 14px rgba(5,150,105,0.25)",
                },
              }}
            >
              {title}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
}
